// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

// Custom
require("slick-carousel")

import $ from 'jquery'
global.$ = $
global.jQuery = $

import './addons/bootstrap.bundle.min.js'
// Modified to include mobile nav fullscreen animation: 
// https://stackoverflow.com/questions/48892380/bootstrap-4-fullscreen-mobile-navbar
// import './addons/bootstrap.bundle.modified.min.js'
// import './addons/bootstrap.bundle.modified.js'

import './addons/remodal.min.js'
import './addons/rellax.min.js'
// import './addons/hammer.min.js'

import './_main.js'


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// const fonts = require.context('../fonts', true)
// const fontPath = (name) => fonts(name, true)
